import script from "./SamplePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SamplePage.vue?vue&type=script&setup=true&lang=js"

import "./SamplePage.vue?vue&type=style&index=0&id=47b6b4a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b6b4a3"]])

export default __exports__